const isSingleAirport = ({ airports, type, filterId }) => {
  const isValidAirport = type === 'AIRPORT' && airports.some((airport) => airport?.value === filterId)
  return airports?.length === 1 && isValidAirport
}

export const getIsSingleOriginOrDestination = ({ originFilter, destinationFilter, type, filterId }) => {
  const origins = originFilter?.filters
  const destinations = destinationFilter?.filters

  return (
    isSingleAirport({ airports: origins, type, filterId }) ||
    isSingleAirport({ airports: destinations, type, filterId })
  )
}
